export class LoaderNotificationModel {
  loadingMessage: string;
  showLoading: boolean;

  constructor(loadingMessage?: string, showLoading?: boolean) {
    this.loadingMessage = loadingMessage ?? 'Loading';
    this.showLoading = showLoading ?? false;
  }
}
